import React from "react";
import styles from "./index.module.css";
import ArrowForwardIcon from "../../assets/co_arrow.png";
import LockIcon from "../../assets/lock_fill.png";
import {
  isCatalyst,
  isSummerCamp,
  catalystRefundPoints,
  catalystRefundPolicyUrl,
  summerCampRefundPoints,
  summerCampRefundPolicyUrl,
} from "../../utils/brandConfig";

const defaultRefundPoints = [
  "All parents are eligible for course credit for the unused classes.",
  "For 6 month installment / subscription plan, refund can be requested only within 15 days from enrollment. Other installment / subscription plans (3 month and lower) are not eligible for refund. Please refer to the Fee Details email regarding the complete refund policy for your future reference.",
];

const Footer = ({ refundPolicyPointList, refundPolicyUrl, businessUnitId }) => {
  const catalystMode = isCatalyst(businessUnitId);
  const summerCampMode = isSummerCamp();

  const policyPoints = summerCampMode
    ? summerCampRefundPoints
    : catalystMode
      ? catalystRefundPoints
      : refundPolicyPointList?.length > 0
        ? refundPolicyPointList
        : defaultRefundPoints;

  const effectiveRefundPolicyUrl = summerCampMode
    ? summerCampRefundPolicyUrl
    : catalystMode
      ? catalystRefundPolicyUrl
      : refundPolicyUrl;

  const openRefundPolicy = () => {
    window.open(effectiveRefundPolicyUrl, "_blank");
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.refundPolicy}>
        <div className={styles.securedInfo}>
          <p className={styles.securedInfoText}>Secured and encrypted</p>
          <img src={LockIcon} className={styles.lockIcon} alt="lock icon" />
        </div>
        <h3 className={styles.title}>Refund policy</h3>
        <ul className={styles.contentList}>
          {policyPoints.map((point, index) => (
            <li key={index} className={styles.contentItem}>
              {point}
            </li>
          ))}
        </ul>
        {effectiveRefundPolicyUrl && (
          <div onClick={openRefundPolicy} className={styles.viewPolicy}>
            View full policy
            <img
              src={ArrowForwardIcon}
              className={styles.arrowUpicon}
              alt="arrow forward"
            />
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
